export const GETDETAILS = "GETDETAILS";

export const ADDUSERDETAILS = "ADDUSERDETAILS";

export const LOGINSTATUS = "LOGINSTATUS";

export const UPDATE_RUNNING_USER = "UPDATE_RUNNING_USER";

export const LOGIN_FAILED = "LOGIN_FAILED";

export const LOGOUT_USER = "LOGOUT_USER";
